import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Spin, Select } from 'antd';
import './assets/css/package.css';
import dummyImage from './assets/Rectangle 187.png';
import calendarIcon from './assets/calendar 1.png';
import breakfastIcon from './assets/croissant.svg';
import wifiIcon from './assets/wi-fi.svg';
import taxiIcon from './assets/location.svg';
import mealIcon from './assets/lunch.svg';
import otherBenefitIcon from './assets/star.svg';

import pencilIcon from './assets/pencil-design.svg';
import { useHistory, useParams } from 'react-router';
import {
  useGetAllPackagesQuery,
  useGetConvertedCurrencyMutation,
} from './packageSlice';
import { useGetFisheryQuery } from '../../fishery_profile/fisherySlice';
import { languages } from './QuoteBooking';

const packages = [
  {
    category: 'DAY TRIP PACKAGES',
    items: [
      {
        title: 'ARAPAIMA & ALLIGATOR | SINGLE ANGLER',
        img: dummyImage,
      },
      {
        title: 'ARAPAIMA & ALLIGATOR | SINGLE ANGLER',
        img: '',
      },
    ],
  },
  {
    category: 'AVAILABLE PACKAGES',
    items: [
      {
        title: 'ARAPAIMA & ALLIGATOR | SINGLE ANGLER',
        img: '',
      },
      {
        title: 'ARAPAIMA & ALLIGATOR | SINGLE ANGLER',
        img: '/path-to-image.jpg',
      },
      {
        title: 'ARAPAIMA & ALLIGATOR | SINGLE ANGLER',
        img: '/path-to-image.jpg',
      },
    ],
  },
  {
    category: 'SINGLE ANGLER PACKAGES',
    items: [
      { title: 'SINGLE ANGLER | 7 NIGHTS', img: '/path-to-image.jpg' },
      { title: 'SINGLE ANGLER | 5 NIGHTS', img: '/path-to-image.jpg' },
    ],
  },
  {
    category: 'SINGLE ANGLER + GUEST PACKAGES',
    items: [
      { title: 'SINGLE ANGLER + GUEST | 7 NIGHTS', img: '/path-to-image.jpg' },
      { title: 'SINGLE ANGLER + GUEST | 5 NIGHTS', img: '/path-to-image.jpg' },
    ],
  },
];
const FishingPackageCard = () => {
  return (
    <div className='package-details-container details'>
      <Row gutter={[40, 20]} className='package-row '>
        {/* Left Image Section */}

        {/* Right Content Section */}
        <Col
          //  xs={24} md={14}
          xs={{ order: 2, span: 24 }}
          md={{ span: 14, order: 1 }}
          className='package-content'
        >
          <h3 className='package-title'>
            TWO ANGLERS | TWO ROOMS | TWO NIGHTS | TWO DAYS FISHING
          </h3>
          <p className='package-description'>
            This is an example of the best Exotic Fishing Thailand package
            description you could ever think of. This is the best resort in
            Thailand and there is not another that even comes close.
          </p>

          {/* Features */}
          <Row gutter={[10, 10]} className='details-package-features'>
            <Col xs={12} sm={8}>
              <span className='feature-item'>
                <img
                  src={calendarIcon}
                  width={14}
                  height={14}
                  alt='benefit'
                  className='mg-right-5'
                />{' '}
                Resort With High-Speed WiFi
              </span>
            </Col>
            <Col xs={12} sm={8}>
              <span className='feature-item'>✅ Breakfast Included</span>
            </Col>
            <Col xs={12} sm={8}>
              <span className='feature-item'>✅ Transfer Included</span>
            </Col>
            <Col xs={12} sm={8}>
              <span className='feature-item'>✅ Boat Included</span>
            </Col>
            <Col xs={12} sm={8}>
              <span className='feature-item'>
                ✅ Use of Rods and Reels (1x Per Angler)
              </span>
            </Col>
            <Col xs={12} sm={8}>
              <span className='feature-item'>✅ Use of Check-Out Included</span>
            </Col>
          </Row>

          {/* Pricing */}
          <div className='package-pricing'>
            <div className='package-details-price-container mg-bottom-10  row-center justify-between'>
              <span className='package-price-label   font-montserrat sb-blue-700'>
                PACKAGE PRICE
              </span>
              <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                £450.00
              </div>
            </div>
            <div className='package-details-price-container  row-center justify-between'>
              <span className='package-price-label   font-montserrat sb-blue-700'>
                PAY TODAY
              </span>
              <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                £150.00
              </div>
            </div>
          </div>

          {/* Booking Button */}
          <Button className='details-book-button'>
            CHECK AVAILABILITY & BOOK NOW
          </Button>
        </Col>
        <Col
          xs={{ order: 1, span: 24 }}
          md={{ span: 10, order: 2 }}
          className='package-image-container'
        >
          <div className='package-image-wrapper'>
            <img
              src={dummyImage}
              alt='Fishing Package'
              className='package-details-image'
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
const AllBookingPackage = () => {
  const fisheryId = useParams()['fishery_id'];

  const { data: allPackages, isLoading: packagesLoading } =
    useGetAllPackagesQuery(fisheryId, {
      skip: !fisheryId,
    });
  const [convertCurrency] = useGetConvertedCurrencyMutation();
  const { data: fisheryData } = useGetFisheryQuery(fisheryId);
  const [currency, setCurrency] = useState(fisheryData?.currency);
  const [ShowMore, setShowMore] = useState(false);
  const [convertedPackages, setConvertedPackages] = useState(allPackages);
  const history = useHistory();
  let CurrencyList = [
    { code: 'GBP', name: 'British Pound Sterling', symbol: '£' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'USD', name: 'United States Dollar', symbol: '$' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  ];
  useEffect(() => {
    setTimeout(() => {
      setCurrency('GBP');
      setCurrencySymbol(CurrencyList.find((i) => i.code === 'GBP')?.symbol);
    }, 1000);
  }, []);
  const languageOptions = languages?.map(({ code, name, flag }) => ({
    label: (
      <span>
        <span>
          <img src={flag} width={14} alt='' className='mg-right-5' />
        </span>
        <span className='txt-underline sb-blue-500'>{name}</span>
      </span>
    ),
    value: code,
  }));
  const [currencySymbol, setCurrencySymbol] = useState('');
  // useEffect(() => {
  //   setCurrency(fisheryData?.currency);
  //   setCurrencySymbol(
  //     CurrencyList.find((i) => i.code === fisheryData?.currency)?.symbol
  //   );
  // }, [fisheryData]);
  useEffect(() => {
    setConvertedPackages(allPackages);
  }, [allPackages]);

  useEffect(() => {
    const convertCartItems = async () => {
      if (!currency || !fisheryData?.currency) return;

      const updatedArray = await Promise.all(
        allPackages.map(async (item) => {
          try {
            const converted = await convertCurrency({
              amount: item?.final_price_in_pence / 100,
              currency_from: fisheryData.currency,
              currency_to: currency,
            }).unwrap();

            return {
              ...item,
              currency: currency,
              convertedAmount: converted,
            };
          } catch (error) {
            console.error('Currency conversion failed:', error);
            return {
              ...item,
              currency: currency,
              convertedAmount: null,
            };
          }
        })
      );

      setConvertedPackages(updatedArray);
    };

    convertCartItems();
  }, [currency]);

  const countryOptions = CurrencyList?.sort(({ code: x }, { code: y }) =>
    x === 'GBP' ? -1 : y === 'GBP' ? 1 : 0
  )?.map(({ code, name }) => ({
    label: (
      <span>
        {name} ({code})
      </span>
    ),
    value: code,
  }));

  return (
    <div>
      {/* Header */}

      <div className='booking-container'>
        {/* Title Section */}
        <Row className='title-section' justify='center'>
          <Col span={24} className='title-content'>
            <h2>
              FISHING HOLIDAY PACKAGES - NOW WITH TWO LAKES TO CHOOSE FROM!
            </h2>
            <p className='fs-18 sb-blue-700 gMedium all-package-description-desktop'>
              Now with TWO Lakes, Exotic Fishing Thailand offers a wide range of
              packages from single days fishing to extended resort stays
              catering for Single Anglers, Couples and Families. Our Day Trip
              Lake is designed and stocked for fishermen who do not have a lot
              of time to spend their holiday fishing due to other commitments
              but they do want to catch an Arapaima! We have created a lake that
              can cater for this group of customers by introducing a large
              number of Arapaima from  1.5mtrs up to 2mtrs+ into a smaller lake
              where it is easier to get a bait in front of them.  In addition to
              Arapaima there are several other ravenous predatory species
              present in the lake including Alligator Gar & Amazon redtail
              catfish and a few other surprises so anglers on a day trip have
              great odds of big fish action.
            </p>
            <div className='fs-18 sb-blue-700 gMedium all-package-description-mobile'>
              {ShowMore
                ? 'Now with TWO Lakes, Exotic Fishing Thailand offers a wide range of packages from single days fishing to extended resort stays catering for Single Anglers, Couples and Families. Our Day Trip Lake is designed and stocked for fishermen who do not have a lot of time to spend their holiday fishing due to other commitments but they do want to catch an Arapaima! We have created a lake that can cater for this group of customers by introducing a large number of Arapaima from  1.5mtrs up to 2mtrs+ into a smaller lake where it is easier to get a bait in front of them.  In addition to Arapaima there are several other ravenous predatory species present in the lake including Alligator Gar & Amazon redtail catfish and a few other surprises so anglers on a day trip havegreat odds of big fish action. '
                : 'Now with TWO Lakes... '}
              <span
                className='sb-blue-500 txt-underline'
                onClick={() => {
                  setShowMore((prev) => !prev);
                }}
              >
                {ShowMore ? 'show less' : 'show more'}
              </span>
            </div>
          </Col>
        </Row>

        {/* Packages Sections */}
        <div
          style={{ margin: '20px 0px' }}
          className='row-center gap-1r flex-wrap'
        >
          <div className='row-center w-full mg-right-0'>
            <div className='row-center w-full  flex-wrap mg-bottom-10 gap-05r'>
              <div className='fs-13 gSemiBold   grey-700 mg-right-20'>
                Select Currency:
              </div>
              <Select
                className='br5  gBold currency-select'
                value={currency}
                onChange={(v) => {
                  setCurrency(v);
                  const selected = CurrencyList.find((c) => c.code === v);
                  if (selected) {
                    setCurrencySymbol(selected.symbol);
                  }
                }}
                optionFilterProp='label'
                popupClassName='payment_form__selector'
                options={countryOptions}
              />
            </div>
          </div>
        </div>
        <Col
          span={24}
          className='package-title fs-22 mg-bottom-10 sb-blue-700  font-montserrat'
        >
          <div>AVAILABLE PACKAGES</div>
        </Col>

        <Row className='package-section' gutter={[16, 16]}>
          {packagesLoading && (
            <div className='row-center justify-center w-full'>
              <Spin />
            </div>
          )}
          {convertedPackages
            ?.filter((item) => item?.show_package_online)
            .map((item, idx) => (
              <Col xs={24} lg={12} xl={8} key={idx} className='package-item'>
                <div className='package-container'>
                  <Row className='package-content gap-1r w-full h-full'>
                    <Col
                      xs={{ order: 2, span: 24 }}
                      sm={{ span: 14, order: 1 }}
                      className='package-details'
                    >
                      <div className='mg-bottom-10 row-center flex-wrap gap-05r'>
                        <div className='package-title sb-blue-700 fs-14  font-montserrat'>
                          {item?.name}
                        </div>
                        <div className='gBold  fs-10 row-center fs-10 mg-left-10'>
                          {item?.package_type === 'last_minute' ||
                          item?.package_type === 'early_bird' ? (
                            <span
                              className=' fs-10 txt-center '
                              style={{
                                borderRadius: '100px',
                                background: '#FFD98F',
                                color: '#5C3D00',
                                width: 120,
                                padding: '2px 12px',
                              }}
                            >
                              {item?.package_type === 'last_minute'
                                ? 'LAST MINUTE'
                                : 'EARLY BIRD'}
                            </span>
                          ) : item?.package_type === 'specific_date_range' ? (
                            <span
                              className=' fs-10 txt-center '
                              style={{
                                borderRadius: '100px',
                                background: '#D9EEFF',
                                color: '#0D3759',
                                width: 120,
                                padding: '2px 12px',
                              }}
                            >
                              DATE RANGE
                            </span>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                      <div className='package-features fs-12 gMedium sb-blue-700'>
                        {item?.included_benefits
                          .filter((b) => b.selected)
                          .slice(0, 4)
                          .map((benefit) => (
                            <div
                              className='row-center '
                              style={{ flex: '1 1 48%' }}
                            >
                              <img
                                src={
                                  benefit?.label === 'Daily Breakfast'
                                    ? breakfastIcon
                                    : benefit?.label === 'Internet'
                                      ? wifiIcon
                                      : benefit?.label === 'Pickup Included' ||
                                          benefit?.label === 'Dropoff Included'
                                        ? taxiIcon
                                        : benefit?.label === 'Meals Included'
                                          ? mealIcon
                                          : ''
                                }
                                className=' mg-right-10'
                                style={{ width: 16, height: 16 }}
                              ></img>{' '}
                              {benefit?.customText
                                ? benefit?.customText
                                : benefit?.label}
                            </div>
                          ))}
                      </div>
                      <div className='package-price-container fs-12 row-center justify-between'>
                        <span className='package-price-label fs-14 font-montserrat sb-blue-700'>
                          PACKAGE PRICE
                        </span>
                        <div className='package-price sb-blue-bg-100 font-montserrat sb-blue-700'>
                          {item?.currency}
                          {item?.convertedAmount ??
                            item?.final_price_in_pence / 100}
                        </div>
                      </div>

                      <div className='package-buttons'>
                        <Button
                          className='view-button'
                          onClick={() => {
                            window.scrollTo(0, 0);
                            history.push(
                              `/booking/package_details/${fisheryId}/${item?.id}`
                            );
                          }}
                        >
                          VIEW PACKAGE
                        </Button>
                        <Button
                          className='book-button'
                          onClick={() => {
                            window.scrollTo(0, 0);
                            history.push(
                              `/booking/package/reservation/${fisheryId}/${item?.id}`
                            );
                          }}
                        >
                          BOOK NOW
                        </Button>
                      </div>
                    </Col>
                    <Col
                      xs={{ order: 1, span: 24 }}
                      sm={{ span: 10, order: 2 }}
                      className='package-image-container row-center'
                    >
                      {item?.package_image ? (
                        <img
                          src={item?.package_image}
                          alt='Fishing Package'
                          className='package-image'
                        />
                      ) : (
                        <div className='package-image sb-blue-bg-600 white fs-20 gSemiBold justify-center center'>
                          No Image
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
        </Row>

        {/* Footer Section */}
        <div className='footer'>
          <div className='footer-box font-montserrat sb-blue-700'>
            CAN'T FIND WHAT YOU'RE LOOKING FOR?
          </div>
          <div
            className='footer-box build-package font-montserrat fs-14 sb-blue-700 cp'
            onClick={() => {
              history.push(`/booking/package/reservation/${fisheryId}`);
            }}
          >
            <img src={pencilIcon} width={42} height={42} alt='Build Icon' />
            <span>BUILD YOUR OWN PACKAGE</span>
          </div>
        </div>
        {/* <FishingPackageCard /> */}
      </div>
    </div>
  );
};
export default AllBookingPackage;
